import { render } from "./credentials.vue?vue&type=template&id=6bfaa26c"
import script from "./credentials.vue?vue&type=script&lang=js"
export * from "./credentials.vue?vue&type=script&lang=js"

import "./credentials.vue?vue&type=style&index=0&id=6bfaa26c&lang=css"

import exportComponent from "/var/www/service/service-cp-company/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__